// extracted by mini-css-extract-plugin
module.exports = {"error":"styles_error__QKDwr","header":"styles_header__YFu9j","accommodationWrapper":"styles_accommodationWrapper__Kjuc4","offerList":"styles_offerList__kjC0q"};